<template>
  <main class="main catalogue">
    <section class="search title-xxs">
      <p class="main-label-filter"><a href="#0" @click.prevent="toggleFilterBar">Filtra risultati</a></p>

      <div class="filters" :class="{'visible': isFilterVisible, 'swiped': isFilterSwiped}" ref="filters">
        <div class="filters-inner">
          <div class="title-mobile" style="position:relative;">FILTRA RISULTATI

            <a class="close-filter-bar" href="#" @click.prevent="toggleFilterBar" style="position:absolute; right:2em">X</a>
            <span></span>
          </div>
          <div class="main-filters">
            <div class="wrapper-filter">
              <toggle-filter label="Repertorio" @update="updateRepertorioToggle" :isActive="repertorio.isActive"></toggle-filter>
              <repertorio-filter label="Repertorio" placeholder="Cerca repertorio" @update="updateRepertorio" :repertorio="repertorio" :isActive="repertorio.isActive"></repertorio-filter>
            </div>
            <div class="wrapper-filter">
              <toggle-filter label="Artisti" @update="updateArtistToggle" :isActive="artist.isActive"></toggle-filter>
              <artist-filter label="Artisti" placeholder="Cerca artista" @update="updateArtist" :artist="artist" :isActive="artist.isActive"></artist-filter>
            </div>
            <div class="wrapper-filter">
              <toggle-filter label="Genere" @update="updateGenreToggle" :isActive="genre.isActive"></toggle-filter>
              <genre-filter label="Genere" placeholder="Cerca genere" @update="updateGenre" :genre="genre" :isActive="genre.isActive"></genre-filter>
            </div>
            <div class="wrapper-filter">
              <toggle-filter label="Album" @update="updateAlbumToggle" :isActive="album.isActive"></toggle-filter>
              <autocomplete-async
                                    :isActive="album.isActive"
                                    :selectedData="album.selectedData"
                                    placeholder="Cerca album"
                                    label="Album"
                                    @update="updateAlbum"
                                    contentType="albums"

              ></autocomplete-async>
            </div>
            <div class="wrapper-filter">
              <toggle-filter label="Brani"  @update="updateSongToggle" :isActive="song.isActive"></toggle-filter>
              <autocomplete-async
                      viewAllLabel="Rimuovi filtro"
                :isActive="song.isActive"
                :selectedData="song.selectedData"
                placeholder="Cerca brano"
                label="Brano"
                @update="updateSong"
                contentType="songs"
              ></autocomplete-async>
            </div>
          </div>

          <div class="order-by-wrapper">
            <p class="label-filter">Ordina per:</p>
            <order-by-selector @update="updateOrderBy" :orderBy="orderBy"></order-by-selector>
          </div>

          <div class="mobile-close-filter-bar-wrapper">
            <a href="#0" class="mobile-close-filter-bar" @click.prevent="closeFilterBar">Vedi i risultati</a>
          </div>
        </div>
      </div>

    </section>

    <div v-if="isUILoaded">
      <router-view 
        :repertorio="repertorio" 
        :artist="artist" 
        :genre="genre" 
        :orderBy="orderBy" 
        :page="page" 
        :queryId="queryId" 
        :album="album" 
        :song="song" 
        ></router-view>

    </div>
  </main>
</template>
  
<script>
import ToggleFilter from './ToggleFilter.vue';
import RepertorioFilter from './RepertorioFilter.vue';
import ArtistFilter from './ArtistFilter.vue';
import GenreFilter from './GenreFilter.vue';
import OrderBySelector from './OrderBySelector.vue';
import Autocomplete from './Autocomplete.vue';
import AutocompleteAsync from './AutocompleteAsync.vue';
import {sortByName} from './../utils/utils.js';
import axios from 'axios/dist/axios';

export default {
  data () {
    return {
      isUILoaded: false,
      
      repertorio: {
        isActive: false,
        data: [],
        activeId: -1
      },

      artist: {
        isActive: false,
        data: [],
        activeId: -1
      },

      genre: {
        isActive: false,
        data: [],
        activeId: -1
      },

      album: {
        isActive: false,
        selectedData: [],
        activeId: -1
      },

      song: {
        isActive: false,
        selectedData: [],
        activeId: -1
      },

      orderBy: {
        data: [
          {name: 'Più recente', id: 'per-data'},
          {name: 'Alfabetico', id: 'alfabetico'}
        ],
        activeId: 'per-data'
      },

      page: 1,

      // this is the trigger for new queries
      // don't use watch $route as it breaks with popstate
      queryId: 0,

      isFilterVisible: true,
      isFilterSwiped: false,
      hasAsyncElements: false,
      prevWindowWidth: -1
    }
  },

  components: {
    'repertorio-filter': RepertorioFilter,
    'artist-filter': ArtistFilter,
    'genre-filter': GenreFilter,
    'order-by-selector': OrderBySelector,
    'toggle-filter': ToggleFilter,
    'autocomplete': Autocomplete,
    'autocomplete-async': AutocompleteAsync
  },

  watch: {
    '$route' (to, from) {
      // means that the user has clicked the 'Catalog' button in the menu while already browsing the catalog

      if(
        from.name == 'Catalog' && 
        to.path == '/catalog/repertorio-tutti/artista-tutti/genere-tutti/album-tutti/brani-tutti/ordine-per-data/pagina-1') 
      {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        this.repertorio.activeId = -1;
        this.artist.activeId = -1
        this.genre.activeId = -1;

        this.album.activeId = -1;
        this.song.activeId = -1;
        
        this.orderBy.activeId = 'per-data';
        this.page = 1;
        this.queryId++;
      }
    }
  },

  created() {
    this.setupUI();
    this.$eventBus.$on('navpage:update', this.updatePage);

    const onPopstate = this.onPopstate.bind(this);
    window.addEventListener('popstate', onPopstate, false);
    const setFiltersHeight = this.setFiltersHeight.bind(this);
    window.addEventListener('resize', setFiltersHeight, false);
  },

  mounted() {
    document.title = 'Caramba - Catalogo';
    this.setupFilterBar();
    this.setFiltersHeight();
  },

  beforeDestroy() {
    const onPopstate = this.onPopstate.bind(this);
    window.removeEventListener('popstate', onPopstate, false);
    const setFiltersHeight = this.setFiltersHeight.bind(this);
    window.removeEventListener('resize', setFiltersHeight, false);
    this.closeFilterBar();
  },

  methods: {

    setupUI: function() {

      console.log("Creating the component", [this.getRepertorioUI(), this.getArtistUI(), this.getGenreUI()]);

      axios.all([this.getRepertorioUI(), this.getArtistUI(), this.getGenreUI()])
        .then(axios.spread((repertorio, artist, genre) => {
          
          this.repertorio.data = repertorio.data.sort(sortByName);
          this.repertorio.data.unshift({name: 'Vedi tutti', slug: "tutti", id: -1});

          this.artist.data = artist.data;
          this.artist.data.unshift({name: 'Vedi tutti', slug: "tutti", id: -1});

          this.genre.data = genre.data.sort(sortByName);
          this.genre.data.unshift({name: 'Vedi tutti', slug: "tutti", id: -1});

          this.setupState();
          this.isUILoaded = true;

          const isEmptyParams = Object.keys(this.$route.params).length === 0;
          if(!isEmptyParams) {
            if(!this.hasAsyncElements) {

              this.updateUrl();
            } else {
              this.asyncUpdateUrl();
            }
          }
        }));
    },

    getRepertorioUI: function() {
      return axios.get(window.location.origin + '/api/v1/category/list');
    },

    getArtistUI: function() {
      return axios.get(window.location.origin + '/api/v1/artist/list');
    },

    getGenreUI: function() {
      return axios.get(window.location.origin + '/api/v1/genre/list');
    },

    setupState: function() {
      const p = this.$route.params;

      const current = {
        repertorio: p.repertorio.replace('repertorio-', ''),
        artist: p.artist.replace('artista-', ''),
        genre: p.genre.replace('genere-', '')
      };

      this.repertorio.activeId = 
        current.repertorio != 'tutti' && current.repertorio != 'undefined' ?
        this.repertorio.data.find(r => r.slug.toLowerCase() == current.repertorio).id : -1;

      this.artist.activeId = 
        current.artist != 'tutti' && current.artist != 'undefined' ?
        this.artist.data.find(r => r.slug.toLowerCase() == current.artist).id : -1;

      this.genre.activeId = 
        current.genre != 'tutti' && current.genre != 'undefined' ?
        this.genre.data.find(r => r.slug.toLowerCase() == current.genre).id : -1;

      this.orderBy.activeId = this.orderBy.data.find(o => o.id == p.orderBy.replace('ordine-', '')).id;

      this.page = parseInt(p.page.replace('pagina-', ''), 10);

      const albumId = p.albums && p.albums.replace('album-', '');
      this.album.activeId = albumId && albumId != 'tutti' && albumId != 'undefined' ? +albumId : -1;

      const songId = p.songs && p.songs.replace('brani-', '');
      this.song.activeId = songId && songId != 'tutti' && songId != 'undefined' ? +songId : -1;

      if(this.album.activeId != -1 || this.song.activeId != -1) {
        this.hasAsyncElements = true;
      }
    },

    updateRepertorioToggle: function(isActive) {



      this.repertorio.isActive = isActive;
      this.swipeToggleFilterBar();

    },

    updateArtistToggle: function(isActive) {
      this.artist.isActive = isActive;
      this.swipeToggleFilterBar();
    },

    updateGenreToggle: function(isActive) {
      this.genre.isActive = isActive;
      this.swipeToggleFilterBar();
    },

    updateAlbumToggle: function(isActive) {
      this.album.isActive = isActive;
      this.swipeToggleFilterBar();
    },

    updateSongToggle: function(isActive) {
      this.song.isActive = isActive;
      this.swipeToggleFilterBar();
    },

    updateRepertorio: function(data) {
      this.repertorio.activeId = data.repertorio.activeId;
      this.page = 1;
      this.album.activeId = -1;
      this.song.activeId = -1;
      this.updateRepertorioToggle(false);
      this.closeFilterBar();
      this.updateUrl();

      this.closeFilterBar();

    },

    updateArtist: function(data) {

      this.artist.activeId = data.artist.activeId;
      this.page = 1;
      this.album.activeId = -1;
      this.song.activeId = -1;
      this.updateArtistToggle(false);
      this.updateUrl();

      this.closeFilterBar();

    },

    updateGenre: function(data) {

      this.genre.activeId = data.genre.activeId;
      this.page = 1;
      this.album.activeId = -1;
      this.song.activeId = -1;
      this.updateGenreToggle(false);
      this.updateUrl();

      this.closeFilterBar();

    },

    updateAlbum: function(data) {

      this.album.isActive = false;
      this.album.selectedData = data != 'tutti' ? data: [];
      this.album.activeId = (data != 'tutti' && data.id) ? data.id :  -1;
      this.album.q = (data.q && !data.id) ? data.q :  '';
      this.page = 1;
      this.repertorio.activeId = -1;
      this.artist.activeId = -1;
      this.genre.activeId = -1;
      this.song.activeId = -1;
      this.updateAlbumToggle(false);
      this.updateUrl();

      this.closeFilterBar();

    },

    updateSong: function(data) {

      this.song.isActive = false;
      this.song.selectedData = data != 'tutti' ? data: [];
      this.song.activeId = (data != 'tutti' && data.id) ? data.id :  -1;
      this.page = 1;
      this.repertorio.activeId = -1;
      this.artist.activeId = -1;
      this.genre.activeId = -1;
      this.album.activeId = -1;
      this.updateSongToggle(false);
      this.updateUrl();

      this.closeFilterBar();

    },

    updateOrderBy: function(data) {
      this.orderBy.activeId = data.orderBy.activeId;
      this.page = 1;
      this.updateUrl();
    },

    updatePage: function(index) {
      this.page = index;
      this.updateUrl();
    },

    asyncUpdateUrl: function() {


      const albumId = this.$route.params.albums.replace('album-', '');
        console.log("So.... semo qua oppure no?", this.$route.params.albums, albumId, typeof albumId)

      const songId = +this.$route.params.songs.replace('brani-', '');
      let queryString = window.location.origin + '/api/v1/album/list?orderby=date&page=1';

      const hasAlbum = !isNaN(albumId);
      const hasSong = !isNaN(songId);

      console.log("hasSong, songId, !isNaN(songId)", hasSong, songId, !isNaN(songId))


      if(hasAlbum) {
        queryString += '&album_id=' + albumId;
      }

      if(hasSong) {
        queryString += '&song_id=' + songId;
      }

      axios.get(queryString)
        .then(resp => {
          if(hasAlbum) this.album.selectedData = resp.data.data[0];
          if(hasSong) this.song.selectedData = resp.data.data[0];
          this.updateUrl();
        });
    },

    updateUrl: function() {
      const r = this.repertorio.data.find(r => r.id == this.repertorio.activeId).slug.toLowerCase();
      const g = this.genre.data.find(g => g.id == this.genre.activeId).slug.toLowerCase();
      const o = this.orderBy.activeId;
      const p = this.page;
      const ar = this.artist.data.find(a => a.id == this.artist.activeId).slug.toLowerCase();


      const al = this.album.selectedData && this.album.activeId != -1 ? this.album.activeId : 'tutti';


      const b = this.song.selectedData && this.song.activeId != -1 ? this.song.activeId : 'tutti';

      const url = `/catalog/repertorio-${r}/artista-${ar}/genere-${g}/album-${al}/brani-${b}/ordine-${o}/pagina-${p}`;
      this.$router.push(url);
      this.queryId++;
    },

    onPopstate: function() {
      const p = this.$route.params;
      // prevents the event from firing when the component is about to be destroyed
      // because popstate fires before beforeDestroy
      if(Object.keys(p).length > 0) {
        this.setupState();
        this.queryId++;
      }
    },

    setupFilterBar() {
      this.isFilterVisible = false;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'initial';
    },

    toggleFilterBar(e) {
      if(!window.mq.over1024) {
        this.isFilterVisible = !this.isFilterVisible;
      } else {
        this.isFilterVisible = true;
      }

      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = this.isFilterVisible ? 'hidden' : 'initial';

    },

    closeFilterBar(e) {


      this.isFilterVisible = false;

      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'initial';

    },

    swipeToggleFilterBar(e) {

      if(!window.mq.over1024) {
        this.isFilterSwiped = !this.isFilterSwiped;
      } else {
        this.isFilterSwiped = true;
      }

    },

    swipeCloseFilterBar() {
      this.isFilterSwiped = false;
    },

    checkSwipeCloseFilterBar() {
      if(!window.mq.over1024) {
        this.isFilterSwiped = false;
      }
    },

    setFiltersHeight() {
      let height = (!window.mq.over1024) ? window.innerHeight + 'px' : 'auto';
      if (this.$refs && this.$refs.filters)
        this.$refs.filters.style.height = height;
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './../css/variables.css';

  .mobile-close-filter-bar,
  .title-mobile {
    display: none;
  }

  @media (max-width: 1023px) {
    .main-label-filter {
      text-align: center;
      padding-bottom: 20px;
      background: white;

      a {
        margin-top: 20px;
        display: inline-block;
        padding: 7px 30px;
        background: var(--aqua);
        font-weight: 400;
      }
    }

    .title-mobile {
      display: block;
      background: var(--light_purple);
      padding: 0 10px;
      text-align: center;
      font-size: 14px;
      font-family: arial, sans-serif;
      width: 50%;
      height: 45px;
      line-height: 45px;
    }

    .order-by-wrapper {
      width: 50%;
      text-align: center;
      text-transform: uppercase;
      font-family: arial, sans-serif;
    }

    .mobile-close-filter-bar-wrapper {
      position: absolute;
      bottom: 20px;
      width: 50%;
      left: 0;
      text-align: center;
    }

    .search {
      overflow: hidden;
    }


    .mobile-close-filter-bar {
      display: inline-block;
      padding: 12px 30px;
      background: var(--azure);
      width: calc(100% - 40px);
      font-size: 18px;
    }

    .filters {
      background: var(--light-grey);
      width: 250px;
      height: 100vh;
      transition: 0.3s all;
      transform: translate(100%, 0);
      will-change: transform;
      position: fixed;
      top: 0;
      right: 0;
      z-index: 50;
      overflow: hidden;

      .filters-inner {
        position: relative;
        width: 200%;
        height: 100%;
        transform: none;
        transition: 0.3s all;
      }

      &.visible {
        transform: translate(0, 0);
      }

      &.swiped {
        .filters-inner {
          transform: translate(-50%, 0);
        }
      }
    }

    .main-filters {
      width: 100%;

      .wrapper-filter {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .toggle {
        flex-basis: 50%;
      }

      .filter {
        flex-basis: 50%;
      }
    }

    .label-filter {
      margin: 10px 0;
      font-size: 14px;
    }
  }

  @media (min-width: 1024px) {
    .search {
      background: white;
    }

    .main-label-filter {
      text-align: center;
      margin: 0 0 20px;
      font-size: 18px;
    }

    .main-filters {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 1024px;
      margin: 0 auto;
      padding: 0 24px;

      .wrapper-filter {
        flex-basis: 180px;
        position: relative;
      }
    }

    .label-filter {
      display: inline;
      margin-right: 10px;
      font-family: arial, sans-serif;
      font-size: 14px;
      text-transform: uppercase;
    }

    .order-by-wrapper {
      text-align: center;
      padding: 33px 0 30px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/components/Catalog.vue